export default __webpack_public_path__ + "static/tile-3-bg-79642fcdfe212ff2735c3930be875512.jpg";